<template>
  <panel>
    <div
      v-for="rootCriterion in documentAssessments"
      :key="`root_criterion_${rootCriterion.id}`"
      class="card-body details-card"
    >
      <div class="row">
        <div class="col-12">
          <h2>Podsumowanie</h2>

          <p>
            Status oceny:

            <strong>{{ assessmentStatus(rootCriterion.id) }}</strong>
          </p>
        </div>
      </div>

      <table class="table">
        <thead>
          <tr>
            <th>Ocena formalna</th>

            <th v-for="assessment in rootCriterion.assessments" :key="`val_header_${assessment.id}`">
              {{ assessmentCreator(assessment) }}
            </th>

            <th>Spełnione</th>
          </tr>
        </thead>

        <tbody>
          <tr v-for="(criterion, index) in rootCriterion.criterions" :key="`criterion_${index}`">
            <td>
              {{ criterion.name }}
            </td>

            <td v-for="assessment in rootCriterion.assessments" :key="`val_${assessment.id}`">
              <div>{{ criterionValue(criterion, assessment) }}</div>

              <div>{{ criterionDescription(criterion, assessment) }}</div>
            </td>

            <td>{{ criterionPassed(criterion.id) }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </panel>
</template>

<script>
import { mapState } from 'vuex';

import Panel from '@/components/panel/Panel';
import { CriterionType } from '@/enums/criterionType';
import {
  FormalAssessmentStatusTranslations,
  FormalAssessmentValue,
  FormalAssessmentValueTranslations
} from '@/enums/formalAssessmentValue.enum';
import { boolean } from '@/filters/boolean';
import { groupCriterions } from '@/utils/criterion';

// @vuese
// Komponent podsumowania oceny
export default {
  components: { Panel },
  filters: { boolean },
  data() {
    return {
      documentAssessments: this.$store.state.criterion.list
        .filter(criterion => !criterion.parentId)
        .map(rootCriterion => {
          return {
            ...rootCriterion,
            criterions: groupCriterions(this.$store.state.criterion.list, rootCriterion),
            assessments: this.filterAssessments(this.$store.state.assessment.list, rootCriterion.id)
          };
        })
    };
  },
  computed: mapState({
    assessments: state => state.assessment.list,
    criterions: state => state.criterion.list.filter(criterion => criterion.type !== CriterionType.SCORE_CONTAINER),
    rootCriterions: state => state.criterion.list.filter(criterion => !criterion.parentId),
    document: state => state.documentIndex.data
  }),
  methods: {
    // @vuese
    // Status oceny
    assessmentStatus(id) {
      const value = this.document.values && this.document.values[`CRITERION_${id}`];
      return (value.passed && FormalAssessmentStatusTranslations[value.passed]) || 'Niezakończona';
    },

    // @vuese
    // Czy kryterium jest spełnione
    criterionPassed(id) {
      const value = this.document.values && this.document.values[`CRITERION_${id}`];
      return (value?.passed && FormalAssessmentValueTranslations[value.passed]) || 'Nieocenione';
    },
    // @vuese
    // Wartość oceny danego kryterium
    criterionValue(criterion, assessment) {
      const value = this.criterionAssessmentValue(criterion, assessment);
      if (criterion.type === CriterionType.BOOL) {
        return (value?.passed && FormalAssessmentValueTranslations[value.passed]) || 'Nieocenione';
      }
      return value.value;
    },
    // @vuese
    // Opis oceny danego kryterium
    criterionDescription(criterion, assessment) {
      return this.criterionAssessmentValue(criterion, assessment)?.description;
    },
    // @vuese
    // Zwraca ocenę danego kryterium
    criterionAssessmentValue(criterion, assessment) {
      return assessment.data.assessments.find(assessmentValue => assessmentValue.criterionId === criterion.id);
    },
    // @vuese
    // Zwraca imię i nazwisko oceniającego
    assessmentCreator(assessment) {
      if (assessment.profile) {
        return assessment.profile.firstName + ' ' + assessment.profile.lastName;
      }
      return 'Ocena automatyczna';
    },
    // @vuese
    // Zwraca oceny powiązane z danym kryterium głównym
    filterAssessments(assessments, rootCriterionId) {
      return assessments.filter(assessment =>
        assessment.data.assessments.some(assessmentValue => assessmentValue.criterionId === rootCriterionId)
      );
    }
  }
};
</script>
